import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext'; // [cite: 339]
import { useNavigate, Link } from 'react-router-dom'; // [cite: 339]
import lawfullingoIcon from '../lawfullingo.jpeg'; // Import your logo [cite: 80]

const RegisterPage = () => {
  const [fullName, setFullName] = useState(''); // [cite: 340]
  const [email, setEmail] = useState(''); // [cite: 340]
  const [password, setPassword] = useState(''); // [cite: 341]
  const [error, setError] = useState(''); // [cite: 341]
  const [loading, setLoading] = useState(false);
  const { register } = useAuth(); // [cite: 341]
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // [cite: 342]

    if (password.length < 6) { // [cite: 343]
      setError("Password must be at least 6 characters long.");
      return; // [cite: 344]
    }
    
    setLoading(true);

    try {
      await register(fullName, email, password); // [cite: 345]
      navigate('/'); // [cite: 345]
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.'); // [cite: 346]
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8">
          <div className="text-center mb-8">
            <img src={lawfullingoIcon} alt="Lawfullingo" className="w-16 h-16 mx-auto rounded-xl shadow-sm" />
            <h1 className="mt-4 text-2xl font-heading font-bold text-slate-900">
              Create Account
            </h1>
            <p className="mt-2 text-sm text-slate-600">
              Start your UGC NET preparation journey today
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="fullName" className="block text-sm font-medium text-slate-700 mb-2">
                Full Name
              </label>
              <input
                id="fullName"
                name="fullName"
                type="text"
                autoComplete="name"
                required
                className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg bg-white transition-all duration-200 focus:outline-none focus:border-slate-400 focus:ring-4 focus:ring-slate-100"
                placeholder="Enter your full name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="email-address" className="block text-sm font-medium text-slate-700 mb-2">
                Email Address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg bg-white transition-all duration-200 focus:outline-none focus:border-slate-400 focus:ring-4 focus:ring-slate-100"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-2">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg bg-white transition-all duration-200 focus:outline-none focus:border-slate-400 focus:ring-4 focus:ring-slate-100"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center px-7 py-3.5 text-sm font-medium text-white bg-slate-900 rounded-lg hover:bg-slate-800 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {loading ? 'Creating Account...' : 'Sign Up'}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-slate-600">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-slate-900 hover:text-slate-700 underline">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;